import React, { useEffect, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Redirect } from 'react-router-dom'
import InternetIssue from '../../components/InternetIssue/InternetIssue'
import LoaderNew from '../../components/LoaderNew/LoaderNew'
import Spinner from '../../components/Spinner/Spinner'
import {
    FETCH_QUESTION_SET,
    HIDE_TIMER,
    IS_TEST_DATA_LOADED,
    UPDATE_CURRENT_QUESTION,
    UPDATE_ACTIVE_SECTION,
    UPDATE_CORRECT_OTP,
    UPDATE_TIME,
    UPDATE_CALCULATED_TIME_LEFT,
} from '../../constants/actionTypes'
import './TestPanel.css'
import TestPanelUI from './TestPanelUI'
import useTestPanelData from './useTestPanelData'
import { onPageLoad as pageLoadAnalytics } from './analytics'

const mapStateToProps = (state) => {
    return {
        active_section: state.active_section,
        testData: state.testpanel,
        testPreviewData: state.testpreview.testPreviewData,
        toggle: state.toggleStatus,
        queryparam: state.queryparam,
        instructions: state.instructions,
        mock_test_submit: state.mock_test_submit,
        current_question: state.current_question,
        pushNotificationEvent: state.pushNotificationEvent,
        testDataConfirmation: state.testDataConfirmation,
        testStatus: state.testStatus,
        deviceId: state.deviceId,
        isExistingTest: state.isExistingTest,
        resumedData: state.resumedData,
        base_url: state.base_url,
        test_duration: state.test_duration,
        current_language: state.current_language,
        disconnect_timer: state.disconnect_timer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onQuestionLoad: (payload) => dispatch({ type: FETCH_QUESTION_SET, payload }),
        hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
        setTestDataLoadedStatus: (payload) =>
            dispatch({ type: IS_TEST_DATA_LOADED, payload }),
        updateCalculatedTimeLeft: (payload) =>
            dispatch({ type: UPDATE_CALCULATED_TIME_LEFT, payload }),
        UpdateCurrentQuestion: (payload) =>
            dispatch({ type: UPDATE_CURRENT_QUESTION, payload }),
        setActiveSection: (payload) =>
            dispatch({ type: UPDATE_ACTIVE_SECTION, payload }),
        setCorrectOTP: (payload) => {
            dispatch({ type: UPDATE_CORRECT_OTP, payload })
        },
        updateTimer: (payload) => {
            return new Promise((resolve, reject) => {
                dispatch({ type: UPDATE_TIME, payload })
                resolve()
            })
        },
    }
}

const TestPanel = (props) => {
    const { t, i18n } = useTranslation()

    const isMock = JSON.parse(sessionStorage.getItem('is_mock'))
    const isPreview =
        sessionStorage.getItem('tp_preview_token') &&
        sessionStorage.getItem('test_id')
            ? true
            : false

    const {
        isError,
        eventType,
        showGoBackPopUp,
        showSpinner,
        errorMsg,
        connection,
        redirectToResults,
        tabSwitchCount,
        showWarningPopup,
        getTabSwitchCount,
        setShowWarningPopup,
        setShowGoBackPopUp,
        setDisconnectTime,
        handleTabSwitch,
        handleExitScreen,
        handlePreviewData,
        handleSectionClick,
        handleTestData,
        handleLogout,
        handleSubmit,
    } = useTestPanelData(props)

    useEffect(() => {
        if (isPreview) {
            handlePreviewData()
        } else {
            !isMock && getTabSwitchCount()
            pageLoadAnalytics(props)
            handleTestData()
        }
    }, [])

    useEffect(() => {
        if (isPreview || isMock) return
        if (
            !(document.fullscreenElement || document.webkitCurrentFullScreenElement)
        ) {
            handleExitScreen()
        }
    }, [document.fullscreenElement, document.webkitCurrentFullScreenElement])

    useEffect(() => {
        if (isPreview || isMock) return
        document.removeEventListener('visibilitychange', handleTabSwitch)
        document.addEventListener('visibilitychange', handleTabSwitch)

        return () => {
            document.removeEventListener('visibilitychange', handleTabSwitch)
        }
    }, [props.current_question?.question?.questionid])

    if (redirectToResults) {
        return <Redirect to="/results" />
    }
    if (showSpinner) {
        return <Spinner message={'Loading'} />
    }

    if (isError) {
        return (
            <InternetIssue
                redirectToInstruction
                isTryAgainVisible={false}
                eventType={eventType}
                baseUrl={props.base_url}
                message={errorMsg !== '' ? t(errorMsg) : t('Something Went Wrong')}
            />
        )
    }

    if (
        props.testData?.questionset?.length > 0 &&
        (props.testDataConfirmation?.isTestDataLoaded || isPreview)
    ) {
        return (
            <TestPanelUI
                props={props}
                isPreview={isPreview}
                isMock={isMock}
                connection={connection}
                tabSwitchCount={tabSwitchCount}
                showWarningPopup={showWarningPopup}
                setShowWarningPopup={setShowWarningPopup}
                setShowGoBackPopUp={setShowGoBackPopUp}
                handleSectionClick={handleSectionClick}
                handleSubmit={handleSubmit}
                active={props.active}
                toggle={props.toggle}
                showGoBackPopUp={showGoBackPopUp}
                current_language={props.current_language}
                instructions={props.instructions}
                testpanel={props.testData}
                setActive={props.setActive}
                handleGTagLogs={props.handleGTagLogs}
                setDisconnectTime={setDisconnectTime}
            />
        )
    }
    if (!props.testDataConfirmation.isTestDataLoaded) {
        return (
            <LoaderNew
                done={50}
                title1={
                    'testData' in props.instructions
                        ? props.instructions?.testData?.title
                            ? props.instructions?.testData?.title[i18n.language]
                            : ''
                        : null
                }
                title2={t('while we are loading your test')}
                title3={null}
                title4={t('PLEASE DO NOT CLOSE THE BROWSER')}
            />
        )
    }

    return <Spinner message={'Loading'} />
}

export default memo(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(TestPanel)),
)
